module.exports = __webpack_public_path__ + "img/trash-03.d94d96ed.svg";